<template lang="pug">
.briq-form-element
  label(:for="name" v-if="label") {{label}}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  textarea.form-element(
    :name="name"
    :id="name"
    :value="innerValue"
    :rows="rows"
    :cols="cols"
    v-bind="$attrs"
    v-on="{...$listeners, input: e => handleInput(e)}"
  )
  p.character-counter(:class="{ 'limit-reached': maxlengthReached }" v-show="showCharacterCounter") {{countLabel}}
  .validation-message(v-if="error") {{ error }}
</template>

<script>
import CharacterCountMixin from './CharacterCountMixin.js'

export default {
  inheritAttrs: false,
  name: 'BriqTextarea',
  props: {
    name: String,
    label: String,
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
    help: String,
    error: String,
    value: [String, Number],
    rows: {
      type: Number,
      default: 4,
    },
    cols: {
      type: Number,
      default: 50,
    },
    withCharacterCounter: Boolean,
    maxLines: Number,
  },
  mixins: [CharacterCountMixin],
  watch: {
    innerValue(newVal) {
      if (this.maxLines && newVal) {
        const splits = newVal.split(/[\n\r]+/)
        if (splits.length > this.maxLines) {
          this.innerValue = splits.slice(0, this.maxLines).join('\n')
        }
      }
    },
  },
}
</script>

<style scoped lang="stylus">
// todo: move styles from forms.less here

.character-counter
  color #c1c1c1
  float right

.limit-reached
  color #ff7901
</style>
